import { createSlice } from "@reduxjs/toolkit";

export const enterpriseWeather = createSlice({
  name: "enterprise_weather",
  initialState: {
    value: {
      status: false,
      data: {},
    },
  },
  reducers: {
    updateEnterpriseWeather: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
    resetEnterpriseWeather: (state, action) => {
      state.value = {
        status: false,
        data: {},
      };
    },
  },
});

export const { updateEnterpriseWeather, resetEnterpriseWeather } =
  enterpriseWeather.actions;

export default enterpriseWeather.reducer;
